import { AiOutlineCheckCircle, AiOutlineCloseCircle } from 'react-icons/ai';
import useImg from '../../../assets/images/user.png'
import { ToTimeJalali } from '../../../../Panel/Common/Function';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
const ItemAthlet = ({ data, timekey, eventPA, isGYM = true, selectAll }) => {
    const navigate = useNavigate();
    const [isSelect, setisSelect] = useState(true)

    return (
        <div className="border rounded p-2 mt-2">
            <div className='row mx-0'>
                <div style={{ flex: "0 0 50px" }}>
                    <img src={useImg} width={38} height={38} />
                </div>
                <div className='flex-fill d-flex align-items-start flex-column justify-content-center nfs-10'>
                    <p>  {data.fullname} </p>
                    <p>  {data.mobile} </p>
                </div>
                <div className='d-flex justify-content-end align-items-center' style={{ flex: "0 0 100px" }}>
                    {!timekey && (isGYM && <button className={"btn border rounded attendanceBtn"}
                        onClick={() => navigate(`/panel/PAList/${data.reserve_id}`)}>
                        لیست حضور
                    </button>)}

                    {timekey &&
                        <>
                            <span onClick={e => {
                                eventPA(!isSelect)
                                if (selectAll) {
                                    setisSelect(!isSelect)
                                }
                            }}>
                                <AiOutlineCheckCircle color={selectAll ? isSelect ? "#1BA462" : '#9A9A9A' : '#9A9A9A'} size={24} />
                            </span>
                            {/* <span>
                                <AiOutlineCloseCircle className='mx-2' color='#9A9A9A' size={24} />
                            </span> */}
                        </>
                    }
                </div>
                {!timekey &&
                    <div className='col-12 nfs-10 mt-2 border-top pt-3'>
                        <p>تاریخ آخرین خرید: {ToTimeJalali(data.date_reserve)}</p>
                        <p className='my-1'>تعداد روزهای باقیمانده: {data.left_days}</p>
                        <p>تعداد حضور: </p>
                    </div>
                }
            </div>
        </div>
    )
}

export default ItemAthlet;